var _rohs = require('./tech-ref/rohs');
var _soc = require('./tech-ref/soc');


/**
 * Module for technical reference on product page
 */
module.exports = {

  /**
   * initlization
   */
  init: function(params) {
    var self = this;

    self.$el = $('.References');

    $.extend(self, params);

    _rohs.init(self);

    _soc.init(self);
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/product/reference.js
// module id = 248
// module chunks = 6